import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WordService {
  constructor() {}

  capitalizeFirstLetter(word: string): string {
    if (word.length === 0) {
      return word;
    }

    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
}
